module.exports = __webpack_public_path__ + "img/成绩管理@2x.1e9e17b2.png";